/* Search strip and Sam chat: predictive search, the chat engine and the bubble.
   Loaded with defer from sections/search-strip.liquid; the Liquid values (translations, pack
   sizes, URLs) come from window.pcbrGuruCfg, written inline by that section. */
  (function () {
    var root = document.querySelector('[data-guru-root]');
    if (!root) return;
    var C = window.pcbrGuruCfg || {};

    /* The sticky-offset measure runs inline in the section, before first paint. */
    /* Predictive search — live product suggestions from /search/suggest.json */
    var sform = root.querySelector('[data-suggest-form]') || document.querySelector('[data-suggest-form]');
    var sInput = sform && sform.querySelector('input[type="search"]');
    var sBox = sform && sform.querySelector('[data-suggest]');
    if (sInput && sBox) {
      var sTimer = null, sSel = -1;
      function sClose() { sBox.hidden = true; sBox.innerHTML = ''; sSel = -1; }
      var startTpl = sform.querySelector('[data-suggest-start]');
      function sStart() {
        if (!startTpl) return;
        sBox.innerHTML = startTpl.innerHTML;
        sBox.hidden = false;
        sSel = -1;
      }
      sInput.addEventListener('focus', function () { if (sInput.value.trim().length < 2) sStart(); });
      /* Predictive search returns the PACK price for the 10-packs and carries no
 metafields, so the pack sizes are handed to JS from Liquid and the
 dropdown quotes per unit like every other surface. */
      var S_PACKS = C.packs || {};
      var S_PER = C.per;

      function sPrice(pr) {
        if (!pr.price) return '';
        var n = S_PACKS[pr.handle];
        if (!n) return '$' + pr.price;
        var unit = parseFloat(String(pr.price).replace(/[^0-9.]/g, '')) / n;
        if (!isFinite(unit)) return '$' + pr.price;
        return '$' + unit.toFixed(2) + ' <span class="s-per">' + S_PER + '</span>';
      }

      function sRender(q, products) {
        var h = '';
        for (var i = 0; i < products.length; i++) {
          var pr = products[i];
          var img = pr.image || (pr.featured_image && pr.featured_image.url) || '';
          h += '<a href="' + pr.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<span class="s-title">' + pr.title + '</span><span class="s-price">' + sPrice(pr) + '</span></a>';
        }
        if (!products.length) h += '<div class="s-none">' + C.noResults + '</div>';
        h += '<a class="s-all" href="' + C.searchUrl + '?q=' + encodeURIComponent(q) + '">' + C.seeAll + ' \u2192</a>';
        sBox.innerHTML = h;
        sBox.hidden = false;
        sSel = -1;
      }
      sInput.addEventListener('input', function () {
        var q = sInput.value.trim();
        clearTimeout(sTimer);
        if (q.length < 2) { sStart(); return; }
        sTimer = setTimeout(function () {
          fetch(C.searchUrl + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
              sRender(q, prods);
            }).catch(function () {});
        }, 180);
      });
      sInput.addEventListener('keydown', function (e) {
        if (sBox.hidden) return;
        var links = sBox.querySelectorAll('a');
        if (e.key === 'Escape') { sClose(); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          sSel = e.key === 'ArrowDown' ? Math.min(sSel + 1, links.length - 1) : Math.max(sSel - 1, 0);
          links.forEach(function (l, i) { l.classList.toggle('is-sel', i === sSel); });
        } else if (e.key === 'Enter' && sSel >= 0) {
          e.preventDefault();
          links[sSel].click();
        }
      });
      document.addEventListener('click', function (e) { if (!sform.contains(e.target)) sClose(); });
    }
    /* ---- Guru chat engine (deterministic v1; Command Center LLM swaps into send later). ----
 Knowledge guardrails: public catalog data + published policies ONLY. No vendor names, no cost
 structures, no personal identities — the guru speaks as pcbracks.com and routes humans to
 /pages/contact and info@pcbracks.com exclusively. */
    var THUMB_BASE = C.thumbBase;
    var GW_CHASSIS = [
      { name: 'B0103', maxL: 355, maxW: 250, picks: { 80: ['B0103GN-80C', 'b0103gn'], 200: ['B0103GM-200C', 'b0103gm'], 300: ['B0103GL HT-300C', 'b0103gl-ht'] }, belt: ['B0103GC BELT-80C', 'b0103gc-belt'] },
      { name: 'B0106', maxL: 460, maxW: 330, picks: { 80: ['B0106GN-80C', 'b0106gn'], 200: ['B0106GM-200C', 'b0106gm'], 300: ['B0106GL HT-300C', 'b0106gl-ht'] }, belt: ['B0106GC BELT-80C', 'b0106gc-belt'] },
      { name: 'B0108', maxL: 535, maxW: 390, picks: { 80: ['B0108GN-80C', 'b0108gn'], 200: ['B0108GM-200C', 'b0108gm'] } },
      { name: 'B0109', maxL: 535, maxW: 460, picks: { 80: ['B0109GN-80C', 'b0109gn'], 200: ['B0109GM-200C', 'b0109gm'], 300: ['B0109GL HT-300C', 'b0109gl-ht'] }, belt: ['B0109GC BELT-80C', 'b0109gc-belt'] },
      { name: 'B0110', maxL: 620, maxW: 460, picks: { 80: ['B0110GN-80C', 'b0110gn'] }, belt: ['B0110GC BELT-80C', 'b0110gc-belt'] }
    ];
    var GW_M = {
      /* maxLen is CUT length (drawing DWD00508 dim B): 460 is wheel span, never cut.
 Both machines quoted at the shared verified 0.6-2.54 mm window (verified against the manuals). */
      vpd3: { sku: 'VPD3-1M', handle: 'vpd3-1m', maxLen: 290, tMin: 0.6, tMax: 1.905, hMax: 33 },
      vpd5: { sku: 'VPD5-330', handle: 'vpd5-330', maxLen: 330, tMin: 0.6, tMax: 2.54, hMax: 20 }
    };
    var T = C.T;
    var openBtn = root.querySelector('[data-guru-open]');
    var G_ASK = { L: T.askLen, W: T.askWid, P: T.askPlen, TH: T.askThick, H: T.askComp };
    var gSlots = [];
    var gEl = root.querySelector('[data-gchat]');
    var gLog = root.querySelector('[data-gchat-log]');
    var gInput = root.querySelector('[data-gchat-input]');
    var gFab = root.querySelector('[data-gchat-fab]');
    var gState = 'idle', gData = {}, gQ = [], gBusy = false, gMark = null, gFlow = null;
    /* Last part discussed: follow-ups like "add 3 more" act on it. Survives
 navigation with the rest of the session so the cart talk stays coherent. */
    var gLast = null;
    var gLLMrun = 0;
    var gSpecDoc = null;   /* product handle whose sheet the visitor asked for */
    try { gLast = JSON.parse(sessionStorage.getItem('pcbr-glast') || 'null'); } catch (e) {}
    function gLastSet(handle, sku) {
      gLast = { handle: handle, sku: sku || '' };
      try { sessionStorage.setItem('pcbr-glast', JSON.stringify(gLast)); } catch (e) {}
    }
    function gAfterSize() {
      if (gFlow === 'r_size' || gState === 'r_size') { gState = 'r_heat'; gFlow = null; gBot(function () { gPush('bot', T.askHeat); gChips([[T.h80, 'h:80'], [T.h200, 'h:200'], [T.h300, 'h:300']]); }); return; }
      gFlow = null;
      gState = 'd_thr'; gBot(function () { gPush('bot', T.askThr); gChips([[T.thrLow, 't:low'], [T.thrHigh, 't:high']]); });
    }
    var GLOC = C.loc;
    /* Transcript format version: stored chat is RENDERED html, so a deploy that
 restyles bubbles must not resurrect old markup. Bump when chat markup changes. */
    var GVER = '3';
    function gSave() {
      /* Session memory: the guru walks with the customer — conversation
 survives page navigation for 20 minutes, then starts fresh. */
      try {
        sessionStorage.setItem('pcbr-gchat', gLog.innerHTML);
        sessionStorage.setItem('pcbr-gchat-ts', String(Date.now()));
        sessionStorage.setItem('pcbr-gchat-loc', GLOC);
        sessionStorage.setItem('pcbr-gchat-ver', GVER);
      } catch (e) {}
    }
    function gScroll() { gLog.scrollTop = gLog.scrollHeight; }
    /* Sam's own face on his messages, not the house P mark. */
    var GAVA = C.ava;
    function gPush(role, html) {
      /* Bot lines carry the P-mark avatar (the chat-app look);
 user lines stay plain bubbles on the right. */
      var row = role === 'bot'
        ? '<div class="grow"><img class="gava" src="' + GAVA + '" alt="" width="26" height="26" loading="lazy"><div class="gmsg bot">' + html + '</div></div>'
        : '<div class="gmsg user">' + html + '</div>';
      gLog.insertAdjacentHTML('beforeend', row);
      gScroll(); gSave();
    }
    function gChips(list) {
      var h = '<div class="gchips">';
      list.forEach(function (c) { h += '<button type="button" data-gc="' + c[1] + '">' + c[0] + '</button>'; });
      gLog.insertAdjacentHTML('beforeend', h + '</div>'); gScroll(); gSave();
    }
    function gActs(list) {
      /* Row of link-buttons: [label, href, 'p' for the one primary]. The shortcut IS the answer. */
      var h = '<div class="gacts">';
      list.forEach(function (a) { h += '<a class="' + (a[2] || 's') + '" href="' + a[1] + '">' + a[0] + '</a>'; });
      gLog.insertAdjacentHTML('beforeend', h + '</div>'); gScroll(); gSave();
    }
    function gCard(sku, handle, meta, qty) {
      /* Every card sells: Add to cart rides ON the card, gold,
 with View as the quiet second. qty > 1 keeps the asked-for amount. */
      var q = Math.max(1, qty || 1);
      var addLbl = q === 1 ? T.add1 : T.addQty.replace('[[n]]', q);
      gLog.insertAdjacentHTML('beforeend', '<div class="gcard"><img loading="lazy" alt="" src="' + THUMB_BASE + 'pcard-' + handle + '.jpg" onerror="this.remove()"><div class="t"><span class="sku">' + sku + '</span><span class="m">' + meta + '</span></div><div class="b"><button type="button" class="btn gc-add" data-gc="add:' + handle + ':' + q + '">' + addLbl + '</button><a class="btn gc-view" href="/products/' + handle + '">' + T.view + '</a></div></div>');
      gScroll(); gSave();
    }
    /* Hormozi closer: add-to-cart inside the chat, then live discount math —
 units to the 10% tier, distributor pricing at pallet scale. */
    function gMoney(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    /* Volume break for whatever Sam is about to offer. Blob is product type +
 title (predictive search returns both). Spares are checked first: their
 titles contain "Magazine Rack" and they carry no tier at all. Anything
 unrecognised returns 0, so the chip falls back to a plain add rather than
 claiming a discount the cart will not give. */
    function gVolBreak(blob) {
      var s = String(blob || '').toLowerCase();
      if (/spare|repuesto|rechange/.test(s)) return 0;
      if (/pack of|paquete|lot de/.test(s)) return 10;
      if (/turntable|giratoria|plateau/.test(s)) return 10;
      if (/magazine rack/.test(s)) return 20;
      return 0;
    }

    function gVolChip(handle, blob, forceQty) {
      var n = forceQty || gVolBreak(blob);
      if (n > 0) return [[T.addVol.replace('[[qty]]', n), 'add:' + handle + ':' + n]];
      return [[T.add1, 'add:' + handle + ':1']];
    }

    function gFamilyCounts(cart) {
      var f = { mag: 0, packs: 0, tt: 0 };
      (cart.items || []).forEach(function (it) {
        var type = (it.product_type || '').toLowerCase();
        var title = (it.title || '').toLowerCase();
        var q = it.quantity || 0;
        if (type === 'magazine rack') f.mag += q;
        else if (type === 'universal rack') {
          if (title.indexOf('turntable') > -1) f.tt += q;
          else if (title.indexOf('pack of') > -1) f.packs += q;
        }
      });
      return f;
    }
    /* One line, for the family closest to (or already past) its own threshold.
 Never invents a discount for a family that has not earned it. */
    function gVolumeNudge(f) {
      if (f.mag >= 20 || f.packs >= 10 || f.tt >= 10) return T.ten;
      if (f.packs >= 5) return T.up5to10.replace('[[more]]', 10 - f.packs);
      if (f.mag > 0) return T.upMag.replace('[[more]]', 20 - f.mag);
      if (f.packs > 0) return T.upPack.replace('[[more]]', 5 - f.packs);
      if (f.tt > 0) return T.upTt.replace('[[more]]', 10 - f.tt);
      return '';
    }

    function gCartLines(cart, removedAll, lead) {
      /* Say what just HAPPENED first ("Added 1 x RA-18C"), then where the cart
 stands. Totals alone read as if Sam ignored the ask. */
      var lines = [];
      if (lead) lines.push(lead);
      lines.push((removedAll ? T.removed : T.added).replace('[[count]]', cart.item_count).replace('[[total]]', gMoney(cart.total_price)));
      if (cart.item_count) {
        /* Discounts are PER FAMILY (magazine racks 20, universal packs 5 then
 10, turntables 10) and spares/kits/machines earn nothing — so the
 nudge must count the family the buyer is actually in. Counting every
 line, as this did, promised 10% on a cart of slot stoppers. */
        var fam = gFamilyCounts(cart);
        var nudge = gVolumeNudge(fam);
        if (nudge) lines.push(nudge);
        /* Shipping is charged by weight on every order, so there is no shipping nudge to
 make here. */
        if (cart.item_count >= 40 || cart.total_price >= 500000) lines.push(T.dist);
      }
      gBot(function () { gPush('bot', lines.join('<br>')); });
      gBot(function () { gActs([[T.actCheckout, '/checkout', 'p'], [T.actModels, '/collections/magazine-racks#compare']]); });
    }
    function gAdd(handle, qty) {
      gLLMrun = 0;
      gLastSet(handle);
      var prod = null;
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        prod = p;
        return fetch(((window.pcbr && window.pcbr.cartUrl) || '/cart') + '/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: p.variants[0].id, quantity: qty }) });
      }).then(function (r) { if (!r.ok) throw 0; return fetch(((window.pcbr && window.pcbr.cartUrl) || '/cart') + '.js'); }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        var label = prod && prod.title ? String(prod.title).split('\u00b7')[0].trim() : handle.toUpperCase();
        gCartLines(cart, false, T.addLine.replace('[[q]]', qty).replace('[[sku]]', gEsc(label)));
      }).catch(function () {
        gBot(function () { gPush('bot', T.addFail); });
      });
    }
    function gSetQty(handle, want) {
      /* want: a number sets the line to exactly that; {dec:n} takes n off. */
      fetch(((window.pcbr && window.pcbr.cartUrl) || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = null;
        for (var i = 0; i < cart.items.length; i++) if (cart.items[i].handle === handle) { line = cart.items[i]; break; }
        if (!line) {
          if (typeof want === 'number' && want > 0) { gAdd(handle, want); return; }
          gBot(function () { gPush('bot', T.skuNeed); });
          return;
        }
        var target = typeof want === 'number' ? want : Math.max(0, line.quantity - want.dec);
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: target }) })
          .then(function (r) { if (!r.ok) throw 0; return fetch(((window.pcbr && window.pcbr.cartUrl) || '/cart') + '.js'); }).then(function (r) { return r.json(); }).then(function (c2) {
            document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = c2.item_count; });
            gCartLines(c2, target === 0);
          });
      }).catch(function () { gBot(function () { gPush('bot', T.addFail); }); });
    }
    /* Part-number brain: a typed SKU is a buying signal, not a
 board measurement. "add 5x RA-18C to my cart" adds five, period; the size
 wizard never sees it. Lookup rides the same predictive search as the strip. */
    function gSkuTokens(txt) {
      var toks = String(txt).match(/[a-z0-9][a-z0-9.\/-]{2,}/gi) || [];
      return toks.map(function (w) { return w.replace(/^[.\/-]+|[.\/-]+$/g, ''); }).filter(function (w) {
        return w.length >= 3 && /[a-z]/i.test(w) && /[0-9]/.test(w) &&
          !/^\d+(?:mm|cm|in|pcs?|x)$/i.test(w) && !/^\d+[x\u00d7]\d+(?:mm|cm|in)?$/i.test(w);
      }).sort(function (a, b) { return b.length - a.length; });
    }
    function gSkuNorm(x) { return String(x).toUpperCase().replace(/[^A-Z0-9]+/g, ''); }
    function gSkuVariants(tok) {
      /* Customers type part numbers loosely: RA18C, ra 18c and RA-18C. all mean
 RA-18C. Try the message's own spelling first, then dashed respellings
 and the letters+digits prefix until the catalog answers. */
      var v = [tok];
      var flat = tok.replace(/[^a-zA-Z0-9]+/g, '');
      v.push(flat);
      for (var i = 1; i < flat.length; i++) {
        if ((/[a-z]/i.test(flat[i - 1]) && /[0-9]/.test(flat[i])) || (/[0-9]/.test(flat[i - 1]) && /[a-z]/i.test(flat[i]))) {
          v.push(flat.slice(0, i) + '-' + flat.slice(i));
        }
      }
      var pm = flat.match(/^([a-zA-Z]+)([0-9]+)/);
      if (pm && pm[0].length >= 3) { v.push(pm[0]); v.push(pm[1] + '-' + pm[2]); if (pm[1].length >= 2) v.push(pm[1]); }
      var seen = {}, out = [];
      v.forEach(function (q) { var k = q.toLowerCase(); if (q.length >= 2 && !seen[k]) { seen[k] = 1; out.push(q); } });
      return out.slice(0, 6);
    }
    function gSkuFind(tok, cb) {
      var tries = gSkuVariants(tok);
      (function next(i) {
        if (i >= tries.length) { cb([]); return; }
        fetch(C.searchUrl + '/suggest.json?q=' + encodeURIComponent(tries[i]) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (prods.length) { cb(prods); return; }
            next(i + 1);
          })
          .catch(function () { next(i + 1); });
      })(0);
    }
    function gSkuHandle(p) { return (String(p.url).split('/products/')[1] || '').split('?')[0].split('/')[0]; }
    function gSkuBest(prods, tok) {
      /* exact normalized match first, then prefix (VPD3-1M beats VPD3-1LB
 when the customer SAID VPD3-1M), else the search's first result */
      var tn = gSkuNorm(tok);
      for (var i = 0; i < prods.length; i++) {
        var n1 = gSkuNorm(gSkuHandle(prods[i])), n2 = gSkuNorm(gSkuLabel(prods[i], ''));
        if (n1 === tn || (n2 && n2 === tn)) return prods[i];
      }
      for (var j = 0; j < prods.length; j++) {
        var m1 = gSkuNorm(gSkuHandle(prods[j])), m2 = gSkuNorm(gSkuLabel(prods[j], ''));
        if (m1.indexOf(tn) === 0 || (m2 && m2.indexOf(tn) === 0)) return prods[j];
      }
      return prods[0];
    }
    function gSkuLabel(p, fallback) {
      /* Titles lead with the canonical part number ("RA-18C \u00b7 Slotted-Edge...").
 Show the customer the real spelling, not their typo. */
      var head = String(p.title || '').split('\u00b7')[0].trim();
      return head && head.length <= 24 ? head : fallback;
    }
    function gSkuFlow(tok, qty, buying) {
      gLLMrun = 0;
      gLog.insertAdjacentHTML('beforeend', '<div class="gtyping" data-gsku><i></i><i></i><i></i></div>');
      gScroll();
      gSkuFind(tok, function (prods) {
        var ty = gLog.querySelector('[data-gsku]');
        if (ty) ty.remove();
        prods = prods.filter(gSkuHandle);
        if (!prods.length) {
          /* A number the catalog does not know is usually another maker's
 number. The alias map crosses it straight to our part; the
 cross-reference page is the fallback for everything else. */
          var xr = window.pcbrXref && window.pcbrXref[gSkuNorm(tok)];
          gBot(function () {
            if (xr) {
              gPush('bot', T.xrefHit.replace('[[sku]]', gEsc(tok.toUpperCase())).replace('[[part]]', gEsc(xr.p)));
              gActs([[xr.p, '/products/' + xr.h, 'p'], [T.xref, /^vpd/.test(xr.h) ? '/pages/depaneler-finder?door=machine&q=' + encodeURIComponent(tok) : '/pages/pcb-rack-finder?door=part&q=' + encodeURIComponent(tok)]]);
            } else {
              gPush('bot', T.skuNone.replace('[[sku]]', gEsc(tok.toUpperCase())));
              gActs([[T.xref, '/pages/pcb-rack-finder?door=part&q=' + encodeURIComponent(tok), 'p'], [T.seeAll, C.searchUrl + '?q=' + encodeURIComponent(tok)], [T.cEng, '/pages/contact']]);
            }
          });
          gMenu();
          return;
        }
        var tn = gSkuNorm(tok);
        var exact = null, pref = [];
        for (var i = 0; i < prods.length; i++) {
          var n1 = gSkuNorm(gSkuHandle(prods[i])), n2 = gSkuNorm(gSkuLabel(prods[i], ''));
          if (n1 === tn || (n2 && n2 === tn)) { exact = prods[i]; break; }
          if (n1.indexOf(tn) === 0 || (n2 && n2.indexOf(tn) === 0)) pref.push(prods[i]);
        }
        /* Confident only when the number matches exactly, or exactly one part
 extends it (RA-18 -> RA-18C). A guess never goes in the cart. */
        var sure = exact || (pref.length === 1 ? pref[0] : null);
        if (sure) {
          var handle = gSkuHandle(sure);
          var label = gSkuLabel(sure, tok.toUpperCase());
          gLastSet(handle, label);
          gBot(function () { gPush('bot', T.skuFound); gCard(gEsc(label), handle, gEsc(sure.title || ''), qty); });
          if (buying) { gAdd(handle, qty); return; }
          gBot(function () { gChips(gVolChip(handle, (sure.type || '') + ' ' + (sure.title || ''))); });
          return;
        }
        /* No confident hit: offer the closest parts, each card sells itself. */
        var top = (pref.length ? pref : prods).slice(0, 3);
        gLastSet(gSkuHandle(top[0]), gSkuLabel(top[0], tok.toUpperCase()));
        gBot(function () {
          gPush('bot', pref.length ? T.skuMulti : T.skuNear.replace('[[sku]]', gEsc(tok.toUpperCase())));
          top.forEach(function (pp) { gCard(gEsc(gSkuLabel(pp, tok.toUpperCase())), gSkuHandle(pp), gEsc(pp.title || ''), qty); });
        });
      });
    }
    /* ---- The real agent: anything the scripted flows don't
 claim goes to the Command Center's public concierge — a live LLM grounded
 in the actual catalog, with lead capture. The script stays as the instant
 lane for sizing, cart math and shortcuts; the LLM does the thinking. ---- */
    /* Spec-pass machinery, SITE-WIDE: the chat lives on every
 page, so Sam must be able to mint download links everywhere — not only
 where the product-page snippet happened to load. Same storage, same
 endpoint; the snippet overwrites with its identical copy when present. */
    if (!window.pcbrSpecs) {
      var SPEC_API = 'https://app.pcbracks.com/.netlify/functions/spec-unlock';
      window.pcbrSpecs = {
        pass: function () { try { var p = JSON.parse(localStorage.getItem('pcbr-specpass') || 'null'); return (p && p.exp > Date.now()) ? p.pass : null; } catch (e) { return null; } },
        url: function (doc) { var p = this.pass(); return p ? SPEC_API + '?doc=' + encodeURIComponent(doc) + '&pass=' + encodeURIComponent(p) : null; },
        unlock: function (payload, cb) {
          payload.tzoff = new Date().getTimezoneOffset();
          payload.page = location.pathname + location.search;
          payload.loc = (document.documentElement.lang || '').slice(0, 5);
          fetch(((window.pcbr && window.pcbr.cartUrl) || '/cart') + '.js').then(function (r) { return r.json(); }).catch(function () { return null; })
            .then(function (cart) {
              if (cart && cart.items && cart.items.length) payload.cart = cart.items.map(function (i) { return i.quantity + 'x ' + (i.sku || i.title); }).join(', ') + ' ($' + (cart.total_price / 100).toFixed(0) + ')';
              return fetch(SPEC_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (d && d.ok) { try { localStorage.setItem('pcbr-specpass', JSON.stringify({ pass: d.pass, exp: d.exp })); localStorage.setItem('pcbr-specinfo', JSON.stringify({ name: payload.name, email: payload.email, company: payload.company })); } catch (e) {} }
              cb(d || { ok: false, error: 'net' });
            })
            .catch(function () { cb({ ok: false, error: 'net' }); });
        }
      };
    }
    var CONCIERGE = 'https://app.pcbracks.com/.netlify/functions/concierge';
    function gConvo() {
      try { return JSON.parse(sessionStorage.getItem('pcbr-gconvo') || '[]'); } catch (e) { return []; }
    }
    function gConvoPush(role, content) {
      var c = gConvo();
      c.push({ role: role, content: content });
      while (c.length > 24) c.shift();
      try { sessionStorage.setItem('pcbr-gconvo', JSON.stringify(c)); } catch (e) {}
      return c;
    }
    function gEsc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
    function gLinkify(t) {
      return t
        .replace(/(https?:\/\/[^\s)]+)/g, '<a href="$1">$1</a>')
        .replace(/(^|[\s(])(\/(?:collections|products|pages)\/[a-z0-9/-]+)/g, '$1<a href="$2">$2</a>')
        .replace(/info@pcbracks\.com/g, '<a href="mailto:info@pcbracks.com">info@pcbracks.com</a>');
    }
    function gLLM(text) {
      gLLMrun++;
      var convo = gConvoPush('user', text);
      gLog.insertAdjacentHTML('beforeend', '<div class="gtyping" data-gllm><i></i><i></i><i></i></div>');
      gScroll();
      var done = false;
      var bail = setTimeout(function () { if (!done) { done = true; finish(null); } }, 16000);
      function finish(reply) {
        clearTimeout(bail);
        var ty = gLog.querySelector('[data-gllm]');
        if (ty) ty.remove();
        if (reply) {
          /* House copy law: no em dashes reach a customer, even from the LLM. */
          reply = reply.replace(/\s+—\s+/g, ', ').replace(/—/g, ',');
          gConvoPush('assistant', reply);
          /* Paragraph breaks survive: the model writes in short blocks and the
 bubble must show them (a wall of text reads as a bad salesperson). */
          gPush('bot', gLinkify(gEsc(reply)).replace(/\n{2,}/g, '<br><br>').replace(/\n/g, '<br>'));
          if (gLLMrun >= 5) {
            /* Five straight free-chat turns with no product progress: the best
 salesperson steers back to the shelf. */
            gLLMrun = 0;
            gBot(function () { gPush('bot', T.offtrack); gActs([[T.cEng, '/pages/contact', 'p']]); });
            gFams();
          }
        } else {
          gPush('bot', T.fallback);
          gActs([[T.cEng, '/pages/contact']]);
          gMenu();
        }
      }
      /* Give the agent the same situational awareness a salesperson standing next
 to the visitor would have: which product is on screen, and what is in the
 cart right now. Cart comes from /cart.js because a cached page can render
 a stale one. A failed cart read must never block the answer. */
      function gCtx(cb) {
        var base = {};
        try { base = Object.assign({}, window.pcbrPage || {}); } catch (e) { base = {}; }
        var settled = false;
        var t = setTimeout(function () { if (!settled) { settled = true; cb(base); } }, 1200);
        fetch(window.pcbr.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (settled) return; settled = true; clearTimeout(t);
            /* Count per FAMILY, because each has its own threshold (magazine
 racks 20, universal packs 5/10, turntables 10). Spares, kits and
 machines earn nothing, so they are deliberately not counted. */
            var mag = 0, packs = 0, tt = 0;
            (c.items || []).forEach(function (it) {
              var type = (it.product_type || '').toLowerCase();
              var title = (it.title || '').toLowerCase();
              var q = it.quantity || 0;
              if (type === 'magazine rack') mag += q;
              else if (type === 'universal rack') {
                if (title.indexOf('turntable') > -1) tt += q;
                else if (title.indexOf('pack of') > -1) packs += q;
              }
            });
            base.cartCount = c.item_count;
            base.cartTotal = (c.total_price != null) ? '$' + (c.total_price / 100).toFixed(2) : '';
            base.magRacks = mag; base.packs = packs; base.turntables = tt;

            /* Line detail so Sam can talk about the cart in the same per-unit terms
 the cart itself shows. final_price is post-discount, so unit tracks
 any volume tier already earned. */
            var sizes = (window.pcbr && window.pcbr.packSizes) || {};
            base.cartLines = (c.items || []).slice(0, 8).map(function (it) {
              var n = sizes[it.handle] || 0;
              var line = { sku: it.sku || '', title: it.title || '', qty: it.quantity || 0,
                           line: '$' + ((it.final_line_price || 0) / 100).toFixed(2) };
              if (n > 1) {
                line.packSize = n;
                line.unit = '$' + ((it.final_price || 0) / n / 100).toFixed(2);
                line.pack = '$' + ((it.final_price || 0) / 100).toFixed(2);
              }
              return line;
            });
            cb(base);
          })
          .catch(function () { if (settled) return; settled = true; clearTimeout(t); cb(base); });
      }
      gCtx(function (ctx) {
        function post(attempt, proof) {
          fetch(CONCIERGE, { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ messages: convo, context: ctx, proof: proof,
              formOpenMs: Date.now() - (window.__gOpenedAt || (Date.now() - 60000)) }) })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (done) return;
              if (d && d.retry && attempt === 0 && window.__pcbProof) {
                /* A token younger than 3s reads as a bot; give the fresh one
 time to age past the server's minimum before the resend. */
                window.__pcbProof.fresh().then(function (p2) { setTimeout(function () { post(1, p2); }, 3300); });
                return;
              }
              done = true; finish(d && d.ok && d.reply ? d.reply : null);
            })
            .catch(function () { if (done) return; done = true; finish(null); });
        }
        var pw = window.__pcbProof ? window.__pcbProof.take() : Promise.resolve(null);
        pw.then(function (proof) { post(0, proof); });
      });
    }
    function gBot(fn) { gQ.push(fn); gDrain(); }
    function gDrain() {
      if (gBusy || !gQ.length) return;
      gBusy = true;
      gLog.insertAdjacentHTML('beforeend', '<div class="gtyping" data-gty><i></i><i></i><i></i></div>');
      gScroll();
      setTimeout(function () {
        var ty = gLog.querySelector('[data-gty]');
        if (ty) ty.remove();
        var fn = gQ.shift();
        if (fn) fn();
        gBusy = false;
        if (gQ.length) { gDrain(); return; }
        gSettle();
      }, 450 + Math.random() * 350);
    }
    function gSettle() {
      /* Chat-app rule: a long answer anchors at its START - product cards stay in view.
 Positions via rect deltas: offsetTop is relative to the offset parent, which is the
 takeover panel (not the log) when the chat is embedded. */
      if (gMark == null) { gScroll(); return; }
      var el = gLog.children[gMark];
      if (!el) { gScroll(); gMark = null; return; }
      var top = el.getBoundingClientRect().top - gLog.getBoundingClientRect().top + gLog.scrollTop;
      if ((gLog.scrollHeight - top) > gLog.clientHeight + 24) {
        gLog.scrollTop = Math.max(0, top - 6);
      } else {
        gLog.scrollTop = gLog.scrollHeight;
      }
      gMark = null;
    }
    function gMenu() { gBot(function () { gChips([[T.cRack, 'rack'], [T.cDep, 'dep'], [T.cSpares, 'spares'], [T.cShip, 'ship'], [T.cTrack, 'track'], [T.cEng, 'eng']]); }); }
    /* Straight-to-the-shelf links, INSIDE the chat (the only place buttons
 live now): the four families plus Get a quote — the full shortcut
 list — and an open-question chip that hands you the keyboard. */
    function gFams() {
      gBot(function () { gActs([[T.actQuote, '/pages/contact', 'p'], [T.famMag, '/collections/magazine-racks'], [T.famUni, '/collections/universal-racks'], [T.famDep, '/collections/depaneling'], [T.famSp, '/collections/rack-spares']]); });
      gBot(function () { gChips([[T.cAsk, 'ask']]); });
    }
    function gGreet() { gBot(function () { gPush('bot', T.greet); }); gMenu(); gFams(); }
    function gNums(txt) {
      var t = String(txt).replace(/,/g, '.');
      var arr = (t.match(/[0-9]+(?:\.[0-9]+)?/g) || []).map(parseFloat);
      var inch = /in\b|inch|\u2033|"|pulgada|pouce/i.test(txt);
      var mm = /\bmm\b|\bcm\b|millim|mil[i\u00ed]met|millim\u00e8tre/i.test(txt);
      return { arr: arr, inch: inch, mm: mm };
    }
    var G_INCHABLE = { L: true, W: true, P: true };
    function gAskNext() {
      var slot = gSlots[0];
      gBot(function () { gPush('bot', G_ASK[slot]); });
    }
    function gHave() {
      var parts = [];
      if (gData.L) parts.push(Math.round(gData.L) + (gData.W ? ' × ' + Math.round(gData.W) : '') + ' mm');
      else if (gData.P) {
        parts.push(Math.round(gData.P) + ' mm');
        if (gData.TH) parts.push(gData.TH + ' mm');
        if (gData.H) parts.push(gData.H + ' mm');
      }
      return parts.join(' · ');
    }
    function gConsume(text) {
      gLLMrun = 0;
      var parsed = gNums(text);
      if (parsed.arr.length && (parsed.inch || parsed.mm)) gData.unitKnown = true;
      parsed.arr.forEach(function (n) {
        if (!gSlots.length || n <= 0) return;
        var slot = gSlots.shift();
        gData[slot] = (parsed.inch && G_INCHABLE[slot]) ? n * 25.4 : n;
      });
      if (gSlots.length) { gAskNext(); return; }
      /* Unit gate: if the customer never SAID mm or inches,
 ask, every time. "50 x 10" is a real board in either unit — assuming
 millimeters recommends the wrong rack for an inches shop. */
      if (!gData.unitKnown) {
        gFlow = gState; gState = 'unit';
        gBot(function () { gPush('bot', T.askUnit); gChips([[T.uMM, 'u:mm'], [T.uIn, 'u:in']]); });
        return;
      }
      gAfterSize();
    }
    function gAnswerRack() {
      var lo = Math.min(gData.L, gData.W), hi = Math.max(gData.L, gData.W), heat = gData.heat;
      var found = null;
      for (var i = 0; i < GW_CHASSIS.length; i++) {
        var ch = GW_CHASSIS[i];
        if (hi <= ch.maxL && lo <= ch.maxW && ch.picks[heat]) { found = { ch: ch, pick: ch.picks[heat] }; break; }
      }
      if (found) {
        var f = found;
        gLastSet(f.pick[1], f.pick[0]);
        gBot(function () { gPush('bot', T.yourRack); gCard(f.pick[0], f.pick[1], T.fits + ' ' + Math.round(hi) + ' × ' + Math.round(lo) + ' mm · ' + T.ratedTo + ' ' + heat + ' °C'); });
        if (f.ch.belt && heat === 80) gBot(function () { gPush('bot', T.beltToo); gCard(f.ch.belt[0], f.ch.belt[1], C.beltMeta); });
        (function (pickHandle) {
          gBot(function () { gPush('bot', T.close); });
          /* This wizard only ever picks magazine racks, so the break is 20. */
          gBot(function () { gChips(gVolChip(pickHandle, '', 20)); });
        })(f.pick[1]);
      } else {
        gBot(function () { gPush('bot', T.oversize.replace(': /pages/contact', '') + ', <a href="/pages/contact">' + T.cEng + '</a>.'); });
      }
      gBot(function () { gPush('bot', T.more); }); gMenu();
      gState = 'idle';
    }
    function gAnswerDep() {
      var elig = [];
      [GW_M.vpd3, GW_M.vpd5].forEach(function (m) {
        if (gData.P <= m.maxLen && gData.TH >= m.tMin && gData.TH <= m.tMax && gData.H <= m.hMax) elig.push(m);
      });
      if (!elig.length) {
        gBot(function () { gPush('bot', T.depNone + ' <a href="/pages/contact">' + T.cEng + '</a>.'); });
      } else {
        var rec = elig.length === 1 ? elig[0] : (gData.high ? GW_M.vpd5 : GW_M.vpd3);
        var alt = elig.length === 2 ? (rec === GW_M.vpd5 ? GW_M.vpd3 : GW_M.vpd5) : null;
        var reason;
        /* With the VPD3 window at 0.6-1.9 mm inside the VPD5's 0.6-2.54 mm and the VPD3's shorter 290 mm cut,
 the only way the VPD3 is the sole fit is component height (VPD5 tops
 out at 20 mm, VPD3 at 33 mm). */
        if (elig.length === 1 && rec === GW_M.vpd3) reason = T.rComp;
        else reason = gData.high ? T.rHigh : T.rLow;
        gLastSet(rec.handle, rec.sku);
        gBot(function () { gPush('bot', T.yourRack); gCard(rec.sku, rec.handle, reason); });
        if (alt) gBot(function () { gCard(alt.sku, alt.handle, T.alsoFits); });
      }
      gBot(function () { gPush('bot', T.more); }); gMenu();
      gState = 'idle';
    }
    /* Is this a question rather than a wizard answer? A "?" is decisive; without
 one we need a question word AND real sentence length, so "320 x 240 mm",
 "about 300", "2.4 mm thick" stay wizard answers. EN/ES/FR. */
    function gAsks(v) {
      var s = String(v || '').trim();
      if (/\?|¿/.test(s)) return true;
      return s.split(/\s+/).length >= 5 && /\b(do|does|did|is|are|can|could|will|would|should|have|what|which|how|why|when|who|puedo|puede|pueden|tiene|tienen|sirve|qu[eé]|cu[aá]l|c[oó]mo|cu[aá]nto|por qu[eé]|est-ce|peut|peuvent|quel|quelle|comment|pourquoi|combien)\b/i.test(s);
    }

    function gHandle(value, label, silent) {
      if (!silent) { gMark = gLog.children.length; gPush('user', label || value); }
      if (gState === 'r_size' || gState === 'd_size') {
        /* A menu chip always beats the wizard: the customer changed lanes. */
        if (/^(rack|dep|spares|ship|track|eng|ask)$/.test(value)) {
          gState = 'idle'; gSlots = []; gFlow = null;
        } else if (gAsks(value)) {
          /* A real question mid-wizard goes to the agent. This
 check has to come BEFORE the number test: "do your racks survive a
 200C bake?" carries a number, so the wizard was swallowing it as
 the board dimension and answering with the next slot prompt. That
 is the wall the dunno branch below was written to avoid. */
          gState = 'idle'; gSlots = []; gFlow = null;
          gLLM(value);
          return;
        } else if (!gNums(value).arr.length) {
          /* No numbers. A wizard that re-asks the same question is a wall, not
 a salesperson: "I don't know" gets a way forward,
 a real question gets the real agent, and only ONE plain re-ask is
 allowed before we open the doors. */
          var dunno = /don'?t know|dont know|no idea|not sure|\bidk\b|\bdunno\b|no lo s[e\u00e9]|no s[e\u00e9]\b|ni idea|no estoy segur|je ne sais pas|sais pas|aucune id[e\u00e9]e|pas s[u\u00fb]r/i.test(value);
          gData.__miss = (gData.__miss || 0) + 1;
          if (dunno || gData.__miss >= 2) {
            var shopHref = gState === 'd_size' ? '/collections/depaneling' : '/collections/magazine-racks#compare';
            gBot(function () {
              gPush('bot', T.dunno);
              gActs([[T.actModels, shopHref, 'p'], [T.cEng, '/pages/contact']]);
            });
            return;
          }
          if (/\?/.test(value) || value.trim().split(/\s+/).length >= 4) {
            gState = 'idle'; gSlots = []; gFlow = null;
            gLLM(value);
            return;
          }
          var have = gHave();
          gBot(function () { gPush('bot', (have ? T.gGot.replace('[[have]]', have) + ' ' : '') + G_ASK[gSlots[0]]); });
          return;
        } else {
          gData.__miss = 0;
          gConsume(value);
          return;
        }
      }
      if (value.indexOf('sp:') === 0) {
        var sp = value.slice(3);
        if (sp === 'rack') { gState = 'sp_model'; gBot(function () { gPush('bot', T.spAskModel); }); return; }
        if (sp === 'v3') {
          gBot(function () { gPush('bot', T.spV3); gCard('VPD3-1CB', 'vpd3-1cb', T.spCbMeta); gCard('VPD3-1LB', 'vpd3-1lb', T.spLbMeta); });
          gBot(function () { gPush('bot', T.spNote); }); gBot(function () { gPush('bot', T.more); }); gMenu();
          return;
        }
        if (sp === 'v5') {
          gBot(function () { gPush('bot', T.spV5); gCard('VPD5-330LK', 'vpd5-330lk', T.spLkMeta); gCard('VPD5-330-P04', 'vpd5-330-p04', T.spPMeta); gCard('VPD5-330-P13', 'vpd5-330-p13', T.spPMeta); });
          gBot(function () { gPush('bot', T.spNote); }); gBot(function () { gPush('bot', T.more); }); gMenu();
          return;
        }
      }
      if (gState === 'sp_model') {
        gState = 'idle';
        var spm = value.match(/b\s*01\s*0?([345689])/i);
        var spMsg = spm ? T.spRackGo.replace('[[chassis]]', 'B010' + spm[1]) : T.spRackAny;
        gBot(function () { gPush('bot', spMsg); });
        gBot(function () { gPush('bot', T.more); }); gMenu();
        return;
      }
      if (value.indexOf('u:') === 0 && gState === 'unit') {
        if (value === 'u:in') { ['L', 'W', 'P', 'TH', 'H'].forEach(function (k) { if (gData[k]) gData[k] = gData[k] * 25.4; }); }
        gAfterSize();
        return;
      }
      if (value.indexOf('h:') === 0 && gState === 'r_heat') { gData.heat = parseInt(value.slice(2), 10); gAnswerRack(); return; }
      if (value.indexOf('t:') === 0 && gState === 'd_thr') { gData.high = value.slice(2) === 'high'; gAnswerDep(); return; }
      /* A sentence routed here by a keyword only donates its numbers when it
 actually reads like a measurement — two numbers, or units, or an ×.
 Otherwise "25 racks" becomes a 25 mm board. */
      function gSizeLike(txt) {
        return gNums(txt).arr.length >= 2 || /\bmm\b|\bcm\b|\bin\b|"|\u2033|[0-9]\s*[x\u00d7]\s*[0-9]/i.test(txt);
      }
      switch (value) {
        case 'rack': gData = {}; gState = 'r_size'; gSlots = ['L', 'W']; gConsume(silent && gSizeLike(label) ? label : ''); return;
        case 'dep': gData = {}; gState = 'd_size'; gSlots = ['P', 'TH', 'H']; gConsume(silent && gSizeLike(label) ? label : ''); return;
        case 'spares':
          gBot(function () { gPush('bot', T.spWho); gChips([[T.spRackChip, 'sp:rack'], [T.spV3Chip, 'sp:v3'], [T.spV5Chip, 'sp:v5']]); });
          return;
        case 'ship': gBot(function () { gPush('bot', T.ansShip); gActs([[T.actShop, '/collections/magazine-racks', 'p'], [T.actQuote, '/pages/contact']]); }); gBot(function () { gPush('bot', T.more); }); gMenu(); return;
        case 'track': gBot(function () { gPush('bot', T.ansTrack); gActs([[T.actOrders, '/account', 'p'], [T.cEng, '/pages/contact']]); }); gMenu(); return;
        case 'eng': gBot(function () { gPush('bot', T.ansEng); gActs([[T.cEng, '/pages/contact', 'p'], ['info@pcbracks.com', 'mailto:info@pcbracks.com']]); }); gMenu(); return;
        case 'ask': gBot(function () { gPush('bot', T.askAway); }); setTimeout(function () { gInput.focus(); }, 600); return;
      }
      /* free text routing. ORDER MATTERS: money questions first — "do I get a
 discount on 25 racks?" mentions racks, but it is a pricing question,
 and the old router fed its "25" straight into the board-length slot. */
      var t = value.toLowerCase();
      /* Spelled-out quantities count too: "buy five RA18C" is qty 5. Routing
 only; the LLM and the size wizard still see the original message. */
      var GWN = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, eleven: 11, twelve: 12, fifteen: 15, twenty: 20, uno: 1, una: 1, dos: 2, tres: 3, cuatro: 4, cinco: 5, seis: 6, siete: 7, ocho: 8, nueve: 9, diez: 10, doce: 12, quince: 15, veinte: 20, un: 1, une: 1, deux: 2, trois: 3, quatre: 4, cinq: 5, sept: 7, huit: 8, neuf: 9, dix: 10, douze: 12, quinze: 15, vingt: 20 };
      t = t.replace(/\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|fifteen|twenty|uno|una|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez|doce|quince|veinte|un|une|deux|trois|quatre|cinq|sept|huit|neuf|dix|douze|quinze|vingt)\b/g, function (w) { return GWN[w]; });
      /* Money talk used to die HERE on a canned "10% volume discount applied"
 — which answered a 2-rack haggle with a false promise.
 Pricing, discounts, and quotes are conversations: they route to the
 agent below, AFTER commands but BEFORE the size wizards, so "discount
 on 25 racks" still can't leak 25 into a board-length slot. */
      /* Spec-sheet requests: if they already unlocked, hand the
 link; otherwise take name/email/company in chat, then hand the link.
 Same gate, same pass, same CRM as the product pages. */
      /* Six products have no standalone sheet; Sam offers what exists and
 routes the rest to a personal follow-up. */
      var G_NO_SHEET = ['frame-plate-kit', 'rack-wear-kit', 'side-panel-kit', 'vpd3-1m-starter-kit', 'vpd3-blade-pair-kit', 'vpd5-330-starter-kit'];
      function gSpecServe(h, label) {
        if (G_NO_SHEET.indexOf(h) > -1) {
          gBot(function () { gPush('bot', T.specPage + ' <a href="/pages/download-information">' + gEsc(label) + '</a>'); });
          return;
        }
        gBot(function () { gPush('bot', T.specPage + ' <a href="/pages/download-information?doc=' + encodeURIComponent(h) + '">' + gEsc(label) + '</a>'); });
      }
      var wantsSpec = /spec ?sheet|datasheet|data sheet|hoja de datos|ficha t[e\u00e9]cnica|fiche technique|especificaciones|documentaci[o\u00f3]n|documentation|pdf/i.test(value);
      if (wantsSpec && window.pcbrSpecs) {
        var st = gSkuTokens(value);
        var docGuess = null;
        if (st.length) {
          docGuess = { tok: st[0] };
        } else if (gLast && gLast.handle) {
          docGuess = { handle: gLast.handle };
        }
        if (!docGuess) { gBot(function () { gPush('bot', T.specNone); }); gMenu(); return; }
        if (docGuess.handle) { gSpecServe(docGuess.handle, (gLast && gLast.sku) || docGuess.handle.toUpperCase()); return; }
        /* they named a part: resolve it, then either link or collect */
        gSkuFind(docGuess.tok, function (prods) {
          prods = prods.filter(gSkuHandle);
          if (!prods.length) { gBot(function () { gPush('bot', T.specNone); }); gMenu(); return; }
          var p0 = gSkuBest(prods, docGuess.tok);
          var h = gSkuHandle(p0);
          gLastSet(h, gSkuLabel(p0, docGuess.tok.toUpperCase()));
          gSpecServe(h, gSkuLabel(p0, h.toUpperCase()));
        });
        return;
      }
      if (gState === 'spec_id') {
        /* one line with name, email, company — parse loosely, validate server-side */
        var em = value.match(/[a-z0-9][a-z0-9._%+-]*@[a-z0-9.-]+\.[a-z]{2,}/i);
        if (!em) { gBot(function () { gPush('bot', T.specAsk); }); return; }
        var rest = value.replace(em[0], ' ').replace(/[,;]+/g, ' ').trim();
        var bits = rest.split(/\s{2,}|\s+at\s+|\s+from\s+|\s+de\s+/i).filter(Boolean);
        var nm = (bits[0] || '').trim().slice(0, 80);
        var co = (bits[1] || '').trim().slice(0, 80);
        var docNow = gSpecDoc;
        gState = 'idle';
        gLog.insertAdjacentHTML('beforeend', '<div class="gtyping" data-gspec><i></i><i></i><i></i></div>');
        gScroll();
        var chatTail = '';
        try { chatTail = [].slice.call(gLog.querySelectorAll('.gmsg')).slice(-8).map(function (el) { return (el.className.indexOf('user') > -1 ? 'C: ' : 'S: ') + el.textContent.trim().slice(0, 110); }).join('\n'); } catch (e) {}
        window.pcbrSpecs.unlock({ name: nm || 'Chat visitor', email: em[0], company: co, doc: docNow, chat: chatTail }, function (d) {
          var ty = gLog.querySelector('[data-gspec]');
          if (ty) ty.remove();
          if (!d || !d.ok) { gBot(function () { gPush('bot', T.specBad); }); return; }
          var u2 = window.pcbrSpecs.url(docNow);
          gBot(function () { gPush('bot', T.specHere + ' <a href="' + u2 + '" target="_blank" rel="noopener">' + gEsc((gLast && gLast.sku) || docNow.toUpperCase()) + '</a>'); });
          gBot(function () { gPush('bot', T.more); });
          gMenu();
        });
        return;
      }
      /* SKU + cart intent beats everything below: it IS the answer, not a question. */
      var skuToks = gSkuTokens(value);
      var qm = t.match(/\b(\d{1,4})\s*[x\u00d7](?=\s|$)/) || t.match(/\b(?:add|buy|order|purchase|get|want|need|take|agrega|anade|a\u00f1ade|compra|pon|quiero|necesito|ajoute|achete|ach\u00e8te|commande|veux|prends)\s+(\d{1,4})\b/) || t.match(/[x\u00d7]\s*(\d{1,4})\b/) || (skuToks.length ? t.match(/(?:^|\s)(\d{1,3})(?=\s)/) : null);
      var cartish = /\b(add|buy|purchase|agrega|anade|a\u00f1ade|compra|pon|ajoute|achete|ach\u00e8te|commande)\b/.test(t) || /\b(cart|carrito|carro|panier)\b/.test(t);
      /* Hoisted so the cart-command branch below can defer to it: a question is
 a question even when it mentions the cart. */
      var asksQ = /\?/.test(value) || /^(what|how|can|do|does|is|are|why|which|when|who|where|qu[e\u00e9]|c[o\u00f3]mo|puede|cu[a\u00e1]l|d[o\u00f3]nde|cu[a\u00e1]ndo|por qu[e\u00e9]|comment|peut|quel|o[u\u00f9]|quand|pourquoi|est-ce)\b/i.test(t);
      if (skuToks.length && (cartish || qm)) {
        gSkuFlow(skuToks[0], qm ? Math.max(1, Math.min(999, parseInt(qm[1], 10) || 1)) : 1, true);
        return;
      }
      /* Follow-up quantities: the cart talk has memory. With a
 last part on record, "add 3 more" / "another one" / "make it 10" /
 "remove 2" act on it, no part number repeated. */
      if (!skuToks.length && gLast) {
        var tt = t.trim();
        var mMore = tt.match(/\b(\d{1,4})\s*(?:more|m[a\u00e1]s|de plus)\b/);
        var oneish = /^(?:please\s+|por favor\s+)?(?:add\s+|agrega\s+|a\u00f1ade\s+|anade\s+|ajoute\s+|pon\s+)?(?:another(?:\s+(?:one|1))?|(?:one|1)\s+more|otr[oa](?:\s+m[a\u00e1]s)?|encore\s+(?:une?|1)?)\s*[.!]?$/.test(tt)
          || /^(?:please\s+|por favor\s+)?(?:add|buy|agrega|a\u00f1ade|anade|compra|pon|ajoute|ach[e\u00e8]te)\s+(?:it|this|that|one|esto|eso|lo|la|\u00e7a|le)\b(?:\s+(?:to|al?|au)\s+(?:my\s+|the\s+|mi\s+|mon\s+)?(?:cart|carrito|carro|panier))?\s*[.!]?$/.test(tt);
        var mAddN = tt.match(/^(?:please\s+)?(?:add|buy|agrega|a\u00f1ade|anade|compra|pon|ajoute|ach[e\u00e8]te)\s+(\d{1,4})\s*[.!]?$/);
        var mSet = tt.match(/\b(?:make it|make that|set (?:it )?to|change (?:it )?to|que sean|c[a\u00e1]mbialo a|cambia a|d[e\u00e9]jalo en|mets \u00e0|passe \u00e0)\s+(\d{1,4})\b/);
        var mRem = tt.match(/^(?:please\s+|por favor\s+)?(?:remove|take\s+out|drop|rem(?:over|ueve|u[e\u00e9]ve)(?:lo|la|los|las)?|qu[i\u00ed]ta(?:lo|la|los|las)?|elim[i\u00ed]na(?:lo|la|los|las)?|s[a\u00e1]ca(?:lo|la|los|las)?|b[o\u00f3]rra(?:lo|la|los|las)?|ret[i\u00ed]ra(?:lo|la|los|las)?|retire[rz]?|supprim(?:er|ez|e)|enl[e\u00e8]ve[rz]?(?:-les?|-la)?)\s*(it|them|all|that|one|uno|una|une|la|lo|los|las|todo|tout|\d{1,4})?(?:\s+(?:from|de|del|du)\s+(?:my\s+|the\s+|mi\s+|mon\s+)?(?:cart|carrito|carro|panier))?\s*[.!]?$/);
        if (mMore) { gAdd(gLast.handle, Math.max(1, Math.min(999, parseInt(mMore[1], 10) || 1))); return; }
        if (oneish) { gAdd(gLast.handle, 1); return; }
        if (mAddN) { gAdd(gLast.handle, Math.max(1, Math.min(999, parseInt(mAddN[1], 10)))); return; }
        if (mSet) { gSetQty(gLast.handle, Math.max(0, Math.min(999, parseInt(mSet[1], 10)))); return; }
        if (mRem) {
          var tok = mRem[1] || '';
          if (/^\d+$/.test(tok)) gSetQty(gLast.handle, { dec: Math.max(1, Math.min(999, parseInt(tok, 10))) });
          else if (/^(one|uno|una|une)$/.test(tok)) gSetQty(gLast.handle, { dec: 1 });
          else gSetQty(gLast.handle, 0);
          return;
        }
      }
      /* "add 5x B0106GN-80C" is a command and belongs here. "what is in my cart
 and what am I paying per rack?" is a QUESTION that merely contains the
 word cart, and it must reach the agent, which is holding the live line
 detail. Without this guard the canned prompt swallowed it. */
      if (cartish && /\b(cart|carrito|carro|panier)\b/.test(t) && !skuToks.length && !asksQ) {
        gBot(function () { gPush('bot', T.skuNeed); });
        return;
      }
      /* QUESTIONS go to the real agent. The keyword wizards below only claim
 plain commands ("racks", "320 x 240") — "are your racks reflow safe?"
 deserves an answer, not a board-length interrogation. */
      if (asksQ) {
        gLLM(value);
        return;
      }
      /* MONEY TALK goes to the agent: discounts, price pushback,
 comparisons, quotes. The agent knows the published rules — automatic
 10% at 20+ racks, kit savings — and closes without inventing numbers. */
      if (/discount|% ?off|cheaper|price ?break|price ?match|expensive|\bcost\b|bulk|volume|descuento|rebaja|\bprecio\b|\bcaro\b|remise|moins cher|tarif|\bcher\b|quote|cotiza|devis/.test(t)) { gLLM(value); return; }
      /* TROUBLE reads as trouble: damaged / return / cancel / wrong
 part went to the track-order chip before — a complaint deserves the
 agent, not a menu. */
      if (/damag|broke|broken|defect|return|refund|warrant|garant|problem|issue|complain|wrong|missing|late|cancel|da[nñ]ad|devoluci|reembolso|retour|remboursement|cass[eé]/.test(t)) { gLLM(value); return; }
      /* A short message that is basically a part number: look it up, no wizard. */
      if (skuToks.length && value.trim().split(/\s+/).length <= 4) { gSkuFlow(skuToks[0], 1, false); return; }
      /* EVERYTHING else typed or injected goes to the agent. The keyword shortcuts that used to
 live here sent "help me build the order" to the canned track-my-order
 answer because the sentence contained "order". Canned flows belong to
 the menu chips ONLY: a click is explicit intent, a word inside a
 sentence is not. The agent knows sizing, pricing, shipping and
 tracking, and runs the same cart tools. */
      gLLM(value);
    }
    /* On a phone the on-screen keyboard covers the bottom of the screen without
 shrinking the page, so a 100dvh sheet keeps its send row UNDER the keys.
 visualViewport reports the actually-visible height; matching the sheet to
 it lifts the input into view and drops it back on dismiss. Desktop and any
 browser without visualViewport keep the plain CSS height. */
    var gVVBound = false;
    function gKeyboardFit() {
      if (!window.visualViewport) return;
      /* Rotating to landscape or widening past the phone breakpoint must hand
 the height back to CSS, or a stale inline value follows the panel. */
      if (!window.matchMedia('(max-width: 560px)').matches) { gEl.style.height = ''; return; }
      if (gEl.hidden) return;
      var vh = window.visualViewport.height;
      if (!(vh > 200)) return;                       /* nonsense reading, leave CSS alone */
      gEl.style.height = vh + 'px';
      var log = gEl.querySelector('.gchat-log');
      if (log) log.scrollTop = log.scrollHeight;
    }
    function gKeyboardTrack(on) {
      if (!window.visualViewport) return;
      if (on && !gVVBound) {
        window.visualViewport.addEventListener('resize', gKeyboardFit);
        gVVBound = true;
      }
      if (!on) { gEl.style.height = ''; }
      gKeyboardFit();
    }
    function gOpen(on) {
      /* the chat pays the same invisible
 proof-of-work as the forms. Solving starts the moment the chat opens,
 so the token is ready before a human finishes their first message. */
      if (on) { window.__gOpenedAt = window.__gOpenedAt || Date.now(); if (window.__pcbProofStart) window.__pcbProofStart(); }
      /* The chat may be living inside the homepage section — floating it from
 the fab reclaims the SAME node, so the transcript rides along. */
      if (on && gEl.classList.contains('gchat--embedded')) window.pcbrGuru.unembed();
      /* The panel's markup ships inside the search-strip section, and that
 wrapper is sticky with its own z-index — a stacking context that pins
 the panel BELOW the site header no matter what z-index it carries.
 Invisible while the chat floats in a corner; on a full-screen phone
 sheet the header painted over Sam's title bar. Adopting the node into
 <body> on open puts it at the top level, where its z-index is honoured.
 Pages that dock the chat in a section re-adopt it on close. */
      if (on && gEl.parentElement !== document.body) document.body.appendChild(gEl);
      if (!on) { gCloseToBubble(); return; }
      gTeaseHide();
      /* Standard chat-widget rule: the window opens FROM the bubble,
 wherever the visitor parked it — never from a stale stored spot that
 might sit off-screen. Default corner when the bubble was never moved.
 MEASURE BEFORE HIDING: a hidden fab reads as a zero rect and once
 sent the window to the top-left corner. Anchor to whichever bubble
 is actually VISIBLE — the desktop robot or the plain mobile fab. */
      var gAf = (function () {
        var b = document.querySelector('[data-gbot-fab]');
        return (b && b.offsetWidth) ? b : gFab;
      })();
      /* Phones open the sheet full-screen, so any stored drag position is
 cleared: a leftover left/top would fight the CSS and re-crumble it. */
      if (window.matchMedia('(max-width: 560px)').matches) {
        gEl.style.left = gEl.style.top = gEl.style.right = gEl.style.bottom = '';
      } else if (gAf.style.left) {
        var fr = gAf.getBoundingClientRect();
        var cw = Math.min(400, window.innerWidth - 24);
        var chh = Math.min(680, window.innerHeight - 48);
        var lx = Math.min(Math.max(8, fr.right - cw), window.innerWidth - cw - 8);
        var ty = fr.top - chh - 12;
        if (ty < 8) ty = Math.min(fr.bottom + 12, window.innerHeight - chh - 8);
        gEl.style.left = lx + 'px';
        gEl.style.top = Math.max(8, ty) + 'px';
        gEl.style.right = 'auto';
        gEl.style.bottom = 'auto';
      } else {
        gEl.style.left = gEl.style.top = gEl.style.right = gEl.style.bottom = '';
      }
      gEl.hidden = false;
      gKeyboardTrack(true);
      gFab.hidden = true;
      gFab.setAttribute('aria-expanded', 'true');
      /* The desktop robot bubble stands down too while the window is open. */
      document.documentElement.classList.add('gchat-open');
      gResume();
      gInput.focus();
    }
    function gCloseToBubble() {
      /* Minimize must TEACH where the chat went: the window visibly
 shrinks INTO the bubble, the bubble takes a little bounce and says the
 chat is saved. On pages with the Talk-to-Sam section the chat also
 re-docks there, so the section never sits as an empty shell after the
 floating window borrowed the node. */
      gKeyboardTrack(false);
      gFab.hidden = false;
      gFab.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('gchat-open');
      var fabV = (function () {
        var b = document.querySelector('[data-gbot-fab]');
        return (b && b.offsetWidth) ? b : gFab;
      })();
      var host = document.querySelector('[data-qa-chat-host]');
      var done = false;
      function settle() {
        if (done) return;
        done = true;
        gEl.hidden = true;
        gEl.style.transition = gEl.style.transform = gEl.style.opacity = '';
        if (host) window.pcbrGuru.embed(host);
        fabV.classList.add('gfab-pop');
        setTimeout(function () { fabV.classList.remove('gfab-pop'); }, 700);
        try { fabV.focus({ preventScroll: true }); } catch (e) {}
        if (!fabV.style.left) gTeaseShow(T.minNote, true);
      }
      var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (gEl.hidden || rm || !fabV.offsetWidth) { settle(); return; }
      var cr = gEl.getBoundingClientRect();
      var br = fabV.getBoundingClientRect();
      gEl.style.transition = 'transform 0.34s cubic-bezier(0.5, 0, 0.75, 0.3), opacity 0.34s ease-in';
      gEl.style.transform = 'translate(' + ((br.left + br.width / 2) - (cr.left + cr.width / 2)) + 'px,' + ((br.top + br.height / 2) - (cr.top + cr.height / 2)) + 'px) scale(0.06)';
      gEl.style.opacity = '0';
      gEl.addEventListener('transitionend', settle, { once: true });
      setTimeout(settle, 420);
    }
    /* Drag the chat anywhere by its header */
    var gHead = gEl.querySelector('.gchat-head');
    var gDrag = null;
    gHead.style.cursor = 'grab';
    gHead.style.touchAction = 'none';
    gHead.addEventListener('pointerdown', function (e) {
      if (gEl.classList.contains('gchat--embedded')) return;
      if (e.target.closest('button')) return;
      var r = gEl.getBoundingClientRect();
      gDrag = { dx: e.clientX - r.left, dy: e.clientY - r.top };
      gEl.style.left = r.left + 'px';
      gEl.style.top = r.top + 'px';
      gEl.style.right = 'auto';
      gEl.style.bottom = 'auto';
      gHead.setPointerCapture(e.pointerId);
      gHead.style.cursor = 'grabbing';
      e.preventDefault();
    });
    gHead.addEventListener('pointermove', function (e) {
      if (!gDrag) return;
      var x = Math.min(Math.max(0, e.clientX - gDrag.dx), window.innerWidth - gEl.offsetWidth);
      var y = Math.min(Math.max(0, e.clientY - gDrag.dy), window.innerHeight - 80);
      gEl.style.left = x + 'px';
      gEl.style.top = y + 'px';
    });
    gHead.addEventListener('pointerup', function () {
      gDrag = null;
      gHead.style.cursor = 'grab';
      try { sessionStorage.setItem('pcbr-gchat-pos', JSON.stringify({ l: gEl.style.left, t: gEl.style.top })); } catch (e) {}
    });
    /* Movable bubble: drag it anywhere; a plain tap still
 opens the chat. Position survives navigation for the session. Generic,
 because the desktop ROBOT bubble wires itself with the same behavior —
 one behavior, two skins, never two systems again. */
    function gWireFab(el, storeKey) {
      try {
        var fp = JSON.parse(sessionStorage.getItem(storeKey) || 'null');
        if (fp && fp.l != null) {
          el.style.left = Math.min(Math.max(0, fp.l), window.innerWidth - 70) + 'px';
          el.style.top = Math.min(Math.max(0, fp.t), window.innerHeight - 70) + 'px';
          el.style.right = 'auto'; el.style.bottom = 'auto';
        }
      } catch (e) {}
      var fd = null, moved = false;
      el.style.touchAction = 'none';
      el.addEventListener('pointerdown', function (e) {
        var r = el.getBoundingClientRect();
        fd = { dx: e.clientX - r.left, dy: e.clientY - r.top };
        moved = false;
        el.setPointerCapture(e.pointerId);
      });
      el.addEventListener('pointermove', function (e) {
        if (!fd) return;
        var x = e.clientX - fd.dx, y = e.clientY - fd.dy;
        var r = el.getBoundingClientRect();
        if (!moved && Math.abs(x - r.left) + Math.abs(y - r.top) < 6) return;
        moved = true;
        el.style.left = Math.min(Math.max(0, x), window.innerWidth - el.offsetWidth) + 'px';
        el.style.top = Math.min(Math.max(0, y), window.innerHeight - el.offsetHeight) + 'px';
        el.style.right = 'auto'; el.style.bottom = 'auto';
        gTeaseHide();
      });
      el.addEventListener('pointerup', function () {
        if (moved) {
          try { sessionStorage.setItem(storeKey, JSON.stringify({ l: parseFloat(el.style.left), t: parseFloat(el.style.top) })); } catch (e) {}
        }
        fd = null;
      });
      /* Opening lives on CLICK, not pointerup: a real button click (mouse,
 touch, Enter, Space, assistive tech) all fire it, and the moved flag
 keeps the tail-end click of a DRAG from popping the window. */
      el.addEventListener('click', function () {
        if (moved) { moved = false; return; }
        gOpen(true);
      });
    }
    gWireFab(gFab, 'pcbr-gfab-pos');
    /* The bubble's speech line. Two jobs, one surface: on a fresh visit it is
 the invite; when a conversation is already in flight it says the chat
 came along. Click-through opens the chat AT the bubble. */
    var gTease = null;
    function gTeaseHide() { if (gTease) { gTease.remove(); gTease = null; } }
    function gTeaseShow(text, sticky) {
      gTeaseHide();
      gTease = document.createElement('div');
      gTease.className = 'gchat-tease';
      gTease.innerHTML = '<button type="button" class="gt-x" aria-label="' + C.closeLbl + '">×</button><span>' + text + '</span>';
      document.body.appendChild(gTease);
      gTease.addEventListener('click', function (e) {
        if (e.target.closest('.gt-x')) { gTeaseHide(); if (!sticky) { try { sessionStorage.setItem('pcbr-gtease', '1'); } catch (er) {} } return; }
        gTeaseHide(); gOpen(true);
      });
      setTimeout(gTeaseHide, sticky ? 9000 : 14000);
    }
    (function () {
      function arrival() {
        if (!gEl.hidden || gEl.classList.contains('gchat--embedded') || gFab.style.left) return;
        /* On a phone the pop-up covers most of the screen width, so it stays shut there.
           The Sam button is still on every page. */
        if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) return;
        var alive = false;
        try {
          var ts = parseInt(sessionStorage.getItem('pcbr-gchat-ts') || '0', 10);
          alive = ts && (Date.now() - ts) < G_TTL && !!sessionStorage.getItem('pcbr-gchat');
        } catch (e) {}
        if (alive) {
          /* The conversation traveled — the BUBBLE says so, briefly. Skip on
 pages that dock the chat; the section shows it in full there. */
          /* No pop-up on arrival: the bubble is enough, chat opens when someone clicks it. */
          return;
        }
        try { if (sessionStorage.getItem('pcbr-gtease')) return; } catch (e) {}
        gTeaseShow(C.tease, false);
      }
      setTimeout(arrival, 2200);
    })();
    if (openBtn) openBtn.addEventListener('click', function () { if (window.pcbrGuruTakeover) { pcbrGuruTakeover.open(); } else { gOpen(true); } });
    root.querySelector('[data-gchat-restart]').addEventListener('click', function () {
      /* Start over: always-visible reset in the header. Wipes
 the conversation and its memory; the cart stays exactly as it is. */
      gQ.length = 0; gBusy = false; gMark = null;
      gState = 'idle'; gData = {}; gSlots = []; gFlow = null; gLast = null;
      try {
        ['pcbr-gchat', 'pcbr-gchat-ts', 'pcbr-gconvo', 'pcbr-glast'].forEach(function (k) { sessionStorage.removeItem(k); });
      } catch (e) {}
      gLog.innerHTML = '';
      gGreet();
    });
    root.querySelector('[data-gchat-close]').addEventListener('click', function () { gEl.classList.remove('gchat--max', 'gchat--min'); gOpen(false); });
    root.querySelector('[data-gchat-min]').addEventListener('click', function () {
      /* Minimize = back to the bubble, like every chat widget people know.
 The transcript is saved; the bubble reopens it. */
      gEl.classList.remove('gchat--max');
      gOpen(false);
    });
    root.querySelector('[data-gchat-max]').addEventListener('click', function () {
      gEl.classList.remove('gchat--min');
      if (gEl.classList.contains('gchat--embedded')) {
        /* Pop the docked chat out into the big floating window — same node,
 same transcript, just more room. */
        window.pcbrGuru.unembed();
        gEl.hidden = false;
        gFab.hidden = true;
        gEl.classList.add('gchat--max');
        gScroll();
        return;
      }
      gEl.classList.toggle('gchat--max');
      gScroll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !gEl.hidden) gOpen(false); });
    gLog.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gc]');
      if (b) {
        var v = b.getAttribute('data-gc');
        if (v.indexOf('add:') === 0) {
          var pa = v.split(':');
          gMark = gLog.children.length;
          gPush('user', b.textContent.trim());
          gAdd(pa[1], parseInt(pa[2], 10) || 1);
          return;
        }
        gHandle(v, b.textContent);
      }
    });
    root.querySelector('[data-gchat-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = gInput.value.trim();
      if (!v) return;
      gInput.value = '';
      gHandle(v);
    });
    var G_TTL = 20 * 60 * 1000;
    function gResume() {
      gQ.length = 0; gBusy = false;
      var prev = null, away = 0;
      try {
        var ts = parseInt(sessionStorage.getItem('pcbr-gchat-ts') || '0', 10);
        var loc = sessionStorage.getItem('pcbr-gchat-loc');
        away = ts ? (Date.now() - ts) : 0;
        var ver = sessionStorage.getItem('pcbr-gchat-ver');
        if (loc === GLOC && ver === GVER && ts && away < G_TTL) prev = sessionStorage.getItem('pcbr-gchat');
        if (!prev) { sessionStorage.removeItem('pcbr-gchat'); sessionStorage.removeItem('pcbr-gchat-ts'); }
      } catch (e) {}
      if (prev) {
        gLog.innerHTML = prev;
        var last = gLog.lastElementChild;
        var resumeTxt = C.resume;
        if (away > 90000 && (!last || last.textContent.indexOf(resumeTxt) === -1)) {
          gPush('bot', resumeTxt);
        }
        gScroll();
      } else {
        gLog.innerHTML = '';
        gGreet();
      }
    }
    /* Strip rides the mega menu: when a dropdown opens, the bar slides down and
 sticks to its bottom edge; when the menu collapses it returns to its place. */
    (function () {
      var bar = document.querySelector('.search-strip');
      var navRoot = document.querySelector('[data-mega-root]');
      if (!bar || !navRoot || !('MutationObserver' in window)) return;
      bar.style.transition = 'transform 0.2s ease';
      function sync() {
        var open = navRoot.querySelector('li.is-open > .mega');
        bar.style.transform = open ? 'translateY(' + open.offsetHeight + 'px)' : '';
      }
      new MutationObserver(sync).observe(navRoot, { attributes: true, subtree: true, attributeFilter: ['class'] });
    })();

    /* Public hook: one brain, many doors. open floats the widget (mobile); embed docks the SAME chat into a container (the desktop guru panel). */
    window.pcbrGuru = {
      open: function (msg) { gOpen(true); if (msg) gHandle(msg); },
      ask: function (msg) { if (msg) gHandle(msg); },
      embed: function (container, msg) {
        if (!container) return;
        /* Docking always arrives full-size: whatever window state the chat
 carried elsewhere (minimized bar, expanded float) is cleared, and
 the header label returns to plain Online. */
        gEl.classList.remove('gchat--min', 'gchat--max');
        var esub = gEl.querySelector('.gchat-head .sub');
        if (esub) esub.textContent = C.online;
        gEl.classList.add('gchat--embedded');
        container.appendChild(gEl);
        gEl.style.left = gEl.style.top = gEl.style.right = gEl.style.bottom = '';
        gEl.hidden = false;
        gFab.hidden = false; /* fab visibility is handled by the desktop CSS; keep state sane for mobile */
        gResume();
        if (msg) gHandle(msg);
        /* No focus grab here: docking happens on page load and after minimize,
 and stealing focus would yank the viewport down to the section. */
      },
      unembed: function () {
        if (!gEl.classList.contains('gchat--embedded')) return;
        gEl.classList.remove('gchat--embedded');
        document.body.appendChild(gEl);
        gEl.hidden = true;
      },
      /* The desktop robot bubble reuses the exact fab behavior (drag + open). */
      wireFab: function (el, storeKey) { gWireFab(el, storeKey || 'pcbr-gbfab-pos'); },
      tease: function (text, sticky) { gTeaseShow(text, sticky); }
    };
  })();
